import { Avatar, Input, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect } from "react";
import { useState } from "react";
import EditableBox from "../../edit/EditableBox";

/**
 * Component to add a new Mahi user
 * @param {{userChanged:Function}} props {userChanged} - function that accepts userDetails
 * @returns 
 */
export function AddNewUser({userChanged}) {

    const [userDetails, setUserDetails] = useState()

    const handleNewUserCancel = (event) => {
        console.log('handleNewUserCancel()')
    }

    const handleNewUserDone = (event) => {
        console.log('handleNewUserDone()')
        if (userChanged && typeof(userChanged) === 'function') {
            userChanged(userDetails)
        }
    }

    /**
     * 
     * @param {{name:String, email:String, phone:String}} userDetails e.g. {name: "", email: "new.user@gmail.com", phone: ""}
     */
    const handleNewUserChange = (userDetails) => {
        console.log('handleNewUserChange()', {userDetails})
        setUserDetails(userDetails)
    }
    
    const editComponent = <AddNewUserForm onNewUserChange={handleNewUserChange} />
    return (
        <EditableBox edit={editComponent} onCancel={handleNewUserCancel} onDone={handleNewUserDone}>
            <DisplayAddNewUser />
        </EditableBox>
    )
}

function DisplayAddNewUser(props) {
    return (
        <Box>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Avatar alt="Add New User" />
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <>
                            <Typography variant="h6" color="secondary">New User</Typography>
                            <Typography variant="body2" color="secondary">new.user@domain</Typography>
                        </>
                    }
                />
            </ListItem>
        </Box>
    )
}

function AddNewUserForm({onNewUserChange}) {
    const [name,  setName]  = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

    useEffect(() => {
        if (onNewUserChange && typeof(onNewUserChange) === 'function') {
            onNewUserChange({name, email, phone})
        }
    // (linter is worried about onNewUserChange but it's an output function)
    // eslint-disable-next-line 
    }, [name, email, phone])

    const handleNameChange = (event, index) => {
        setName(event.target.value)
    }

    const handleEmailChange = (event, index) => {
        setEmail(event.target.value)
    }

    const handlePhoneChange = (event, index) => {
      setPhone(event.target.value)
  }

    return (
        <Box>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Avatar alt="Add New User" />
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <>
                            <Typography variant="h6" color="secondary" sx={{pb: 2}}>
                                <Input value={name} type="text" placeholder="Name" onChange={handleNameChange}/>
                            </Typography>
                            <Typography variant="body2" color="secondary" sx={{pb: 2}}>
                                <Input value={email} type="email" placeholder="Email" onChange={handleEmailChange} sx={{width: '310px'}} />
                            </Typography>
                            <Typography variant="body2" color="secondary" sx={{pb: 2}}>
                                <Input value={phone} type="text" placeholder="Phone" onChange={handlePhoneChange} sx={{width: '310px'}} />
                            </Typography>
                        </>
                    }
                />
            </ListItem>
        </Box>
    )
}